module.exports = __webpack_public_path__ + "static/media/car-black-icon.28d6f0f3.svg";